<script lang="ts">
	interface Props {
		headline?: string;
		linkTitle?: string;
		class?: string;
	}

	let { headline = '', linkTitle = '', class: className }: Props = $props();
</script>

<div class={className}>
	<p class="text-brown-2">{headline}</p>

	<a
		class="font-semibold text-green-3"
		href="https://support.mill.com/"
		target="_blank"
		rel="noreferrer"
	>
		{linkTitle}
	</a>
</div>
